// Density
export const lightSquareSize = 4
export const normalSquareSize = 6
export const extraSquareSize = 8
export const tripleSquareSize = 10
